module.exports = __webpack_public_path__ + "static/media/Mondadori-logomark-dark.5866f57e.svg";